import { config } from './config'

const API_BASE = config.apiUrl

export function apiUrl(path) {
  // When API_BASE includes a subpath (e.g. /api/kagami), strip the /api prefix
  // from the path to avoid double /api (e.g. /api/kagami/api/auth/me)
  if (API_BASE && API_BASE.includes('/api/') && path.startsWith('/api')) {
    return `${API_BASE}${path.slice(4)}`
  }
  return `${API_BASE}${path}`
}

export function setAuthToken(token) {
  if (token) {
    localStorage.setItem('auth_token', token)
  } else {
    localStorage.removeItem('auth_token')
  }
}

export function getAuthToken() {
  const fromStorage = localStorage.getItem('auth_token')
  if (fromStorage) return fromStorage

  // localStorage can be evicted while the session is still valid (Safari ITP,
  // privacy modes, a different frontend origin). The backend issues the same
  // JWT as the readable `auth` cookie, so fall back to it to stay authenticated.
  const match = document.cookie.match(/(?:^|;\s*)auth=([^;]+)/)
  return match ? decodeURIComponent(match[1]) : null
}

export async function apiFetch(path, options = {}) {
  const token = getAuthToken()
  const headers = {
    ...(options.headers || {}),
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
  }

  // Auto-set Content-Type for JSON string bodies if not already set
  if (options.body && typeof options.body === 'string' && !headers['Content-Type'] && !headers['content-type']) {
    try {
      JSON.parse(options.body)
      headers['Content-Type'] = 'application/json'
    } catch (_) {
      // Not JSON, leave as-is
    }
  }

  return fetch(apiUrl(path), {
    credentials: 'include',
    ...options,
    headers,
  })
}
